import React from 'react';
import { ColorRing } from 'react-loader-spinner';

interface LoadingOverlayProps {
  mapHeight: number;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ mapHeight }) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: `${mapHeight}px`,
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1001,
      }}
    >
      <ColorRing
        visible
        height="80"
        width="80"
        ariaLabel="color-ring-loading"
        wrapperStyle={{}}
        wrapperClass="color-ring-wrapper"
        colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
      />
    </div>
  );
};
